"use strict";

var config = require("app/util/config/config");
var APICaller = require("./api-caller");

module.exports = new APICaller(config.app.integrationsURL);



// WEBPACK FOOTER //
// ./app/util/api/integrations-api.js